/* [Modified by Codex at 2026-11-03] 独立加购搭配商品并隔离主商品属性及购物车刷新 */
(() => {
  'use strict';

  const elementName = 'product-pairs-well-with';
  if (customElements.get(elementName)) return;

  let cartQueue = Promise.resolve();
  const buttonRequests = new WeakMap();
  const defaultLabels = {
    add: 'ADD',
    adding: 'Adding...',
    added: 'Added',
    error: 'Unable to add this item. Please try again.',
    uncertain: 'We could not confirm whether this item was added. Check your cart before trying again.',
    viewCart: 'View cart',
  };

  const route = (path) => {
    const root = window.Shopify?.routes?.root || '/';
    return `${root.endsWith('/') ? root : `${root}/`}${path}`;
  };
  const getCart = () => document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const sectionIdsFor = (cart) => {
    if (typeof cart?.getSectionsToRender !== 'function') return [];
    return [...new Set(cart.getSectionsToRender().map((section) => section.id).filter(Boolean))].slice(0, 5);
  };
  const restoreAttribute = (element, name, value) => {
    if (value === null) element.removeAttribute(name);
    else element.setAttribute(name, value);
  };
  const enqueue = (task) => {
    const pending = cartQueue.then(task);
    cartQueue = pending.catch(() => {});
  };

  async function readJson(url) {
    const response = await fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to refresh the cart.');
    return response.json();
  }

  function renderSections(sections, ids, cart) {
    if (!cart || !ids.length || !sections) return false;
    let rendered = false;
    ids.forEach((id) => {
      const markup = sections[id];
      const target = document.getElementById(id);
      if (typeof markup !== 'string' || !target) return;
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const form = parsed.querySelector('#form-mini-cart');
      if (!form) return;
      target.innerHTML = form.innerHTML;
      rendered = true;

      const beside = cart.querySelector('.bls-recommendations-beside');
      const nextBeside = parsed.querySelector('.bls-recommendations-beside');
      if (beside && nextBeside) beside.innerHTML = nextBeside.innerHTML;

      const countdown = cart.querySelector('.cart-countdown-time');
      const nextCountdown = parsed.querySelector('.cart-countdown-time');
      if (countdown && nextCountdown) countdown.innerHTML = nextCountdown.innerHTML;
      else if (!countdown && nextCountdown && target.parentElement && typeof cart.countdownTimer === 'function') {
        const inserted = nextCountdown.cloneNode(true);
        target.before(inserted);
        cart.cartCountDown = inserted;
        cart.startTime = Date.now();
        cart.countdownTimer();
      }
    });
    if (rendered) {
      cart.classList.remove('is-empty');
      if (typeof cart.cartAction === 'function') cart.cartAction();
      if (window.BlsLazyloadImg?.init) window.BlsLazyloadImg.init();
      if (window.BlsSettingsSwiper?.init) window.BlsSettingsSwiper.init();
    }
    return rendered;
  }

  function updateCartTotals(cartState, cart) {
    if (!cartState || typeof cartState.item_count !== 'number') return false;
    document.querySelectorAll('.cart-count').forEach((element) => {
      element.textContent = element.classList.contains('cart-count-drawer')
        ? `(${cartState.item_count})` : String(cartState.item_count);
    });
    document.querySelectorAll('header-total-price').forEach((element) => {
      if (typeof element.updateTotal === 'function') element.updateTotal(cartState);
    });
    document.querySelectorAll('free-ship-progress-bar').forEach((element) => {
      if (typeof element.init === 'function') element.init(cartState.items_subtotal_price);
    });
    if (cart) cart.currentItemCount = cartState.item_count;
    return true;
  }

  async function refreshCart(sections, ids) {
    const cart = getCart();
    const totalsPromise = readJson(route('cart.js')).catch(() => null);
    let rendered = false;
    try { rendered = renderSections(sections, ids, cart); } catch (error) { /* A successful add must not be retried for a rendering error. */ }
    if (!rendered && cart && ids.length) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', ids.join(','));
        rendered = renderSections(await readJson(`${url.pathname}${url.search}`), ids, cart);
      } catch (error) { /* Keep the confirmed add and offer the cart page. */ }
    }
    const cartState = await totalsPromise;
    let totalsUpdated = false;
    try { totalsUpdated = updateCartTotals(cartState, cart); } catch (error) { /* Other cart indicators can recover on the next refresh. */ }
    return { cart, rendered, totalsUpdated };
  }

  async function addVariant(variantId, ids) {
    const body = { items: [{ id: variantId, quantity: 1 }] };
    if (ids.length) {
      body.sections = ids;
      body.sections_url = window.location.pathname;
    }
    let response;
    try {
      response = await fetch(route('cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
    } catch (error) {
      return { kind: 'uncertain' };
    }
    let data;
    try { data = await response.json(); } catch (error) {
      return { kind: response.ok || response.status >= 500 || response.status === 400 ? 'uncertain' : 'error' };
    }
    if (!data || typeof data !== 'object') return { kind: response.ok ? 'uncertain' : 'error' };
    if (!response.ok || data.errors || Number(data.status) >= 400) {
      return {
        kind: response.status >= 500 || response.status === 400 ? 'uncertain' : 'error',
        message: typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : '',
      };
    }
    const items = Array.isArray(data.items) ? data.items : data.id ? [data] : [];
    if (!items.some((item) => item && String(item.variant_id || item.id) === String(variantId))) return { kind: 'uncertain' };
    return { kind: 'added', sections: data.sections };
  }

  class ProductPairsWellWith extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      this.labelTimers = new Map();
      this.addEventListener('click', (event) => this.onClick(event), { signal: this.abortController.signal });
      this.querySelectorAll('[data-pww-add]').forEach((button) => {
        const record = buttonRequests.get(button);
        if (record?.completed) this.finishButton(button, record);
        else if (!record && button.dataset.pwwState === 'added') {
          button.textContent = this.label('add');
          delete button.dataset.pwwState;
        }
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      this.labelTimers?.forEach((timer) => clearTimeout(timer));
      this.labelTimers?.clear();
    }

    label(name) {
      return this.dataset[`label${name[0].toUpperCase()}${name.slice(1)}`] || defaultLabels[name];
    }

    canUpdate(button) {
      return this.isConnected && this.contains(button) && this.abortController && !this.abortController.signal.aborted;
    }

    status(button, message, kind, withCartLink = false) {
      if (!this.canUpdate(button)) return;
      const row = button.closest('[data-pww-item]');
      const status = row?.querySelector('[data-pww-status]');
      if (!status) return;
      status.textContent = message;
      status.dataset.state = kind;
      if (withCartLink) {
        const link = document.createElement('a');
        link.href = route('cart');
        link.textContent = this.label('viewCart');
        status.append(' ', link);
      }
    }

    onClick(event) {
      const button = event.target.closest('[data-pww-add]');
      if (!button || button.closest(elementName) !== this || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      if (buttonRequests.has(button)) return;
      event.preventDefault();
      const variantId = Number(button.dataset.variantId);
      if (!Number.isSafeInteger(variantId) || variantId <= 0) {
        this.status(button, this.label('error'), 'error');
        return;
      }
      const record = {
        completed: false,
        originalDisabled: button.disabled,
        originalAriaDisabled: button.getAttribute('aria-disabled'),
        originalAriaBusy: button.getAttribute('aria-busy'),
        originalLabel: button.textContent.trim() || this.label('add'),
      };
      buttonRequests.set(button, record);
      clearTimeout(this.labelTimers.get(button));
      this.labelTimers.delete(button);
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
      button.dataset.pwwState = 'adding';
      button.textContent = this.label('adding');
      this.status(button, this.label('adding'), 'adding');
      enqueue(async () => {
        let ids = [];
        try {
          const cart = getCart();
          ids = sectionIdsFor(cart);
          if (this.canUpdate(button) && typeof cart?.setActiveElement === 'function') cart.setActiveElement(button);
          record.result = await addVariant(variantId, ids);
          const refresh = record.result.kind === 'error' ? null : await refreshCart(record.result.sections, ids);
          record.withCartLink = record.result.kind === 'uncertain' || !refresh?.rendered || !refresh?.totalsUpdated;
          if (refresh?.rendered && this.canUpdate(button) && typeof refresh.cart?.open === 'function') refresh.cart.open();
        } catch (error) {
          // Preserve a confirmed response even if theme UI code throws afterwards.
          record.result = record.result || { kind: 'error' };
          record.withCartLink = true;
        } finally {
          record.completed = true;
          if (this.canUpdate(button)) this.finishButton(button, record);
        }
      });
    }

    finishButton(button, record) {
      if (!this.canUpdate(button)) return;
      const result = record.result || { kind: 'error' };
      button.disabled = record.originalDisabled;
      restoreAttribute(button, 'aria-disabled', record.originalAriaDisabled);
      restoreAttribute(button, 'aria-busy', record.originalAriaBusy);
      button.dataset.pwwState = result.kind;
      button.textContent = result.kind === 'added' ? this.label('added') : record.originalLabel;
      const message = result.kind === 'added' ? this.label('added')
        : result.kind === 'uncertain' ? this.label('uncertain') : result.message || this.label('error');
      this.status(button, message, result.kind, record.withCartLink);
      buttonRequests.delete(button);
      if (result.kind === 'added') {
        const timer = setTimeout(() => {
          this.labelTimers.delete(button);
          if (this.canUpdate(button) && button.dataset.pwwState === 'added') {
            button.textContent = record.originalLabel;
            delete button.dataset.pwwState;
          }
        }, 1400);
        this.labelTimers.set(button, timer);
      }
    }
  }

  customElements.define(elementName, ProductPairsWellWith);
})();
/* [End] */
